<template>
    <v-textarea v-bind="{ ...attrs_input_common, ...$attrs }" filled>
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-textarea>
</template>

<script>
import { attrs_input_common } from "@/assets/variables";

export default {
    props: {
    },
    components: {},
    data: () => {
        return {
            attrs_input_common,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
